angular.module('tgaAdmin').controller('HeaderController', [
  '$scope',
  '$rootScope',
  '$state',
  '$window',
  '$cookies',
  '$filter',
  '$uibModal',
  'userService',
  'gameService',
  'domainService',
  'authService',
  'localStorageService',
  'notificationService',
  function (
    $scope,
    $rootScope,
    $state,
    $window,
    $cookies,
    $filter,
    $uibModal,
    userService,
    gameService,
    domainService,
    authService,
    localStorageService,
    notificationService,
  ) {
    $scope.$state = $state;
    $scope.pageTitle = $scope.$parent.title || $state.current.data.title;
    $scope.notificationService = notificationService;

    $scope.$watch('$parent.title', () => {
      if (angular.isDefined($scope.$parent.title)) {
        $scope.pageTitle = $scope.$parent.title;
      }
    });

    const redirectKey = 'tgaRedirect';

    $scope.showBack = $scope.$parent.showBack;

    $scope.data = {
      user: null,
      games: [],
      domains: [],
    };

    $scope.viewmodel = {
      gameId: null,
      domain: domainService.domain,
      soonestExpiration: null,
    };

    $scope.expiration = {
      isExpiring: false,
      isExpired: false,
      whenExpired: null,
    };

    $scope.initialize = function () {
      $('#aside').modal('hide'); // Hide slideout nav
      $('body').removeClass('modal-open').css('padding-right', 0);
      $('.modal-backdrop').remove();

      $scope.data.user = userService.getUserData();

      if ($scope.data.user && $scope.data.user.domains) {
        for (let i = 0; i < $scope.data.user.domains.length; i++) {
          $scope.data.domains.push({
            name: `${$scope.data.user.domains[i]}.${domainService.base}`,
            value: $scope.data.user.domains[i],
          });
        }
      }

      // check if anything expiring soon
      domainService.checkExpiration().then((expired) => {
        if (expired) {
          domainService.getSoonestExpiration().then((duration) => {
            // if minutes is less than or equal to 15 days
            if (duration.minutes <= 60 * 24 * 15) {
              $scope.expiration.isExpiring = true;
              $scope.expiration.whenExpired = duration.whenExpired;
              // if minutes is less then or equal to 0 then it's expired
              if (duration.minutes <= 0) {
                $scope.expiration.isExpired = true;
              }
            }
          });
        }
      });
    };

    $scope.actions = {
      toggleNav() {
        $('#aside').modal('show');
      },
      requestChangeDomain() {
        // need to perform domain logging if super admin is trying to reach client domain
        if (domainService.isDomainLoggingRequired($scope.data.user, $scope.viewmodel.domain)) {
          $scope.actions.domainLoggingModal();
        } else {
          $scope.actions.changeDomain();
        }
      },
      domainLoggingModal() {
        $uibModal
          .open({
            animation: true,
            templateUrl: 'templates/partials/modal-domain-logging.html',
            controller: 'DomainLoggingController',
            backdrop: true,
            size: 'lg',
            resolve: {
              desiredDomain: () => $scope.viewmodel.domain,
              externalLogin: () => false,
            },
          })
          .result.then((reason) => {
            const { submitted } = reason;
            if (submitted) {
              $scope.actions.changeDomain();
            }
          })
          .catch(() => {
            $scope.viewmodel.domain = domainService.domain;
          });
      },
      notificationsModal() {
        $uibModal
          .open({
            animation: true,
            templateUrl: 'templates/partials/modal-notifications.html',
            controller: 'NotificationsController',
            backdrop: true,
            windowClass: 'flex',
          })
          .result.catch(angular.noop);
      },
      changeDomain() {
        const expireDate = new Date();
        expireDate.setDate(expireDate.getDate() + 1);

        $scope.data.user.key = authService.getAuthentication().token;
        $scope.data.user.two_factor_device = authService.getDeviceToken();

        // Too much data will break the cookie
        // Will add back on login
        delete $scope.data.user.domains;
        delete $scope.data.user.data;
        delete $scope.data.user.custom_fields;

        $cookies.putObject(redirectKey, $scope.data.user, {
          path: '/',
          domain: `.${domainService.base}`,
          expires: expireDate,
        });

        userService.logout();

        $window.location.href = `${$window.location.protocol}//${$scope.viewmodel.domain}.${domainService.base}/admin/v1/login`;
      },
      logout() {
        $rootScope.actions.logout();
      },
      back() {
        // eslint-disable-next-line no-unused-expressions
        $state.current.data.back ? $state.go($state.current.data.back) : $window.history.back();
      },
    };

    $scope.$on('refreshDomains', () => {
      $scope.data.domains = [];
      $scope.data.user = userService.getUserData();

      if ($scope.data.user && $scope.data.user.domains) {
        for (let i = 0; i < $scope.data.user.domains.length; i++) {
          $scope.data.domains.push({
            name: `${$scope.data.user.domains[i]}.${domainService.base}`,
            value: $scope.data.user.domains[i],
          });
        }
      }
    });

    $scope.initialize();
  },
]);
